
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    methods: {
        async showDialog(){
            this.$data.dialog = true;
            var self = this;
            return new Promise(function (resolve, reject) {
                self.$data.resolve = resolve;
            });
        },
        handleNo: function () {
            this.$data.dialog = false;
            this.$data.resolve(false);
        },
        handleYes: function () {
            this.$data.dialog = false;
            this.$data.resolve(true);
        }
    }
})
export default class ConfirmDelete extends Vue {
    dialog = false;
    private resolve = null;
    private reject = null;
}
